import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "vuetify/lib/components/VAutocomplete/VAutocomplete.css";
import "vuetify/lib/components/VSnackbar/VSnackbar.css";

import { vuetifyConfig } from "@haskoning/vue-component-library";
import { createVuetify } from "vuetify";

const SPECKLE_COLOR = "#047EFB";

const FIELD_LIST_PROPS = { class: "haskoning-list-surface", elevation: 0 };

const theme = typeof vuetifyConfig.theme === "object" ? vuetifyConfig.theme : {};
const defaultThemeName = theme.defaultTheme ?? "haskoningLight";
const defaultTheme = theme.themes?.[defaultThemeName] ?? {};

export default createVuetify({
  ...vuetifyConfig,
  defaults: {
    ...vuetifyConfig.defaults,
    VSelect: { ...vuetifyConfig.defaults?.VSelect, listProps: FIELD_LIST_PROPS },
    VAutocomplete: { ...vuetifyConfig.defaults?.VAutocomplete, listProps: FIELD_LIST_PROPS },
  },
  theme: {
    ...theme,
    themes: {
      ...theme.themes,
      [defaultThemeName]: {
        ...defaultTheme,
        colors: { ...defaultTheme.colors, speckleColor: defaultTheme.colors?.primary ?? SPECKLE_COLOR },
      },
    },
  },
});
